import { render, staticRenderFns } from "./NewUserDialog.vue?vue&type=template&id=32af3da3&scoped=true"
import script from "./NewUserDialog.vue?vue&type=script&lang=js"
export * from "./NewUserDialog.vue?vue&type=script&lang=js"
import style0 from "./NewUserDialog.vue?vue&type=style&index=0&id=32af3da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af3da3",
  null
  
)

export default component.exports